<template>
    <div
        class="main-navbar row"
        style="text-align: center"
    >
        <div class="col-6 col-sm-12">
            <main-navbar-button
                title="Dashboard"
                route="/dashboard"
                icon="dashboard"
            ></main-navbar-button>
        </div>
        <div
            v-if="getApplicationSetting('ipad_planning') === '1'"
            class="col-6 col-sm-12"
        >
            <main-navbar-button
                title="Planning"
                route="/planning"
                icon="planning"
            ></main-navbar-button>
        </div>
        <div
            v-if="getApplicationSetting('ipad_transfer_notes') === '1' || getApplicationSetting('ipad_announcements') === '1' || getApplicationSetting('ipad_documents') === '1'"
            class="col-6 col-sm-12"
        >
            <main-navbar-button
                title="Administratie"
                route="/transfer/messages"
                icon="transfer"
            ></main-navbar-button>
        </div>
        <div
            v-if="getApplicationSetting('ipad_child_activities') === '1' || getApplicationSetting('ipad_go_child_activities') === '1'  || getApplicationSetting('portal_child_activities') === '1'"
            class="col-6 col-sm-12"
        >
            <main-navbar-button
                title="Logboek"
                route="/activities"
                icon="activities"
            ></main-navbar-button>
        </div>
        <div
            v-if="getApplicationSetting('ipad_message') === '1' || getApplicationSetting('ipad_go_message') === '1' || getApplicationSetting('portal_child_messages') === '1'"
            class="col-6 col-sm-12"
        >
            <main-navbar-button
                title="Berichten"
                :badge="hasUnreadChatMessages"
                route="/chat"
                icon="chat"
            ></main-navbar-button>
        </div>
        <div
            v-if="getApplicationSetting('ipad_photos') === '1' || getApplicationSetting('portal_child_photo') === '1'"
            class="col-6 col-sm-12"
        >
            <main-navbar-button
                title="Foto's"
                route="/photos"
                icon="photos"
            ></main-navbar-button>
        </div>
        <div
            v-if="getApplicationSetting('ipad_care') === '1'"
            class="col-6 col-sm-12"
        >
            <main-navbar-button
                title="Verzorging"
                route="/care"
                icon="care"
            ></main-navbar-button>
        </div>
        <div class="col-6 col-sm-12">
            <main-navbar-button
                title="Kinderen"
                route="/children"
                icon="child"
            ></main-navbar-button>
        </div>
        <div
            v-if="getApplicationSetting('child_tracking_system') === '1'"
            class="col-6 col-sm-12"
        >
            <main-navbar-button
                title="Kindvolgsysteem"
                route="/childtrackingsystem/analyse"
                icon="childtrackingsystem"
            ></main-navbar-button>
        </div>
<!--        Hamburger menu grid small -->
        <div
            v-if="getApplicationSetting('ipad_employee_present') === '1'"
            class="col-6 d-sm-none"
        >
            <main-navbar-button
                title="Medewerkers"
                route="/employees"
                icon="employee"
                :fontSize="'1.5rem'"
            ></main-navbar-button>
        </div>
        <div class="col-6 d-sm-none">
            <main-navbar-button
                title="Andere groep"
                route="/select-group"
                icon="switch"
            ></main-navbar-button>
        </div>
        <div class="col-6 d-sm-none">
            <main-navbar-button
                title="Over"
                route="/about"
                icon="info"
            ></main-navbar-button>
        </div>
        <div class="col-6 d-sm-none">
            <main-navbar-button
                title="Uitloggen"
                route="/logout"
                icon="logout"
            ></main-navbar-button>
        </div>
<!--        Hamburger menu grid small end-->
    </div>
</template>

<script>
import MainNavbarButton from '@/components/Main-Navbar-Button'

export default {
    name: 'main-navbar',
    components: {
        MainNavbarButton
    },
    data() {
        return {
            interval: null,
            hasNewMessages: false
        }
    },
    computed: {
        hasUnreadChatMessages() {
            return this.$store.getters.hasUnreadChatMessages
        }
    },
    created() {
        this.$store.dispatch('updateHasUnreadChatMessages')
        clearInterval(this.interval)
        var app = this
        this.interval = setInterval(function () {
            app.$store.dispatch('updateHasUnreadChatMessages')
        }, 30000)

    },
    unmounted() {
        clearInterval(this.interval)
    }
}
</script>

<style scoped>
* {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
}

@media (max-width: 767px) {
    .col-6:nth-child(odd) {
        padding-right: 0;
    }

    .col-6:nth-child(even) {
        padding-left: 0;
    }
}
</style>
